module.exports = __webpack_public_path__ + "static/media/pholidoptera_griseoaptera_004_APA.856c8fbe.mp3";